import React from "react";

export default function Complete({ clienttype }) {
  const close = () => {
    if (clienttype === "4") {
      // Android (TS.43)
      if (typeof window.VoWiFiWebServiceFlow === "object") {
        window.VoWiFiWebServiceFlow.entitlementChanged();
      }
      return;
    }

    // iOS (default)
    if (typeof window.WiFiCallingWebViewController === "object") {
      window.WiFiCallingWebViewController.phoneServicesAccountStatusChanged();
    }
  };

  return (
    <div>
      <h2>Wi-Fi Calling has been successfully setup on your account.</h2>
      <button onClick={close}>Close</button>
    </div>
  );
}
